/*
 * @Author: Teemo Ding
 * @Date: 2022-04-14 13:44:07
 * @LastEditTime: 2022-08-19 13:10:51
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Permissions/PermissionDetail/config.tsx
 */
import React from 'react';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import css from './style.module.less';
import {
  handleOnGetStoreTimezoneUTC,
  handleOnFormatStoreTimeAndDateWithTimezone,
  replaceI18nVariables,
} from '@/src/tools/tools';

export const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '',
    name: getI18n('usersAndPermissions.list.usersandPermissions'),
  },
];

export const columns = ({ getI18n }) => [
  {
    title: getI18n('usersAndPermissions.detail.location'),
    dataIndex: ['location', 'region'],
    key: 'location',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 192,
  },
  {
    title: getI18n('usersAndPermissions.detail.iPAddress'),
    dataIndex: 'ip',
    key: 'ip',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 256,
  },
  {
    title: getI18n('usersAndPermissions.detail.device'),
    dataIndex: 'device',
    key: 'device',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 256,
  },
  {
    title: `${replaceI18nVariables(
      getI18n('usersAndPermissions.detail.date'),
      handleOnGetStoreTimezoneUTC(),
    )}`,
    dataIndex: 'modifiedDate',
    key: 'modifiedDate',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 384,
    childGenerate: (text) => (
      <NoWrapContainer>
        <Tooltip title={handleOnFormatStoreTimeAndDateWithTimezone(text)}>
          {handleOnFormatStoreTimeAndDateWithTimezone(text)}
        </Tooltip>
      </NoWrapContainer>
    ),
  },
];
